// covered-by: frontends/carrie/src/ask-v2/pages/__tests__/AskV2ProjectPage.test.tsx
import { MAX_ASK_PUNTT_PROJECT_NAME_LENGTH } from "@mg/schemas/src/christo/askPunttProject";
import { useTranslation } from "react-i18next";

import { BreadcrumbInlineRename } from "../../components/BreadcrumbInlineRename";
import { useRenameAskPunttProject } from "../../utils/queries/askPunttProjects";

interface AskV2ProjectBreadcrumbTitleProps {
  projectId: string;
  name: string;
  /** Only the project owner may rename. Members get a read-only title. */
  canEdit: boolean;
}

/**
 * Project name in the Ask Puntt v2 project header. For the owner it is an inline
 * rename affordance via {@link BreadcrumbInlineRename}; edits persist through
 * {@link useRenameAskPunttProject} with optimistic cache updates for the header
 * and sidebar recents.
 */
export function AskV2ProjectBreadcrumbTitle({
  projectId,
  name,
  canEdit,
}: AskV2ProjectBreadcrumbTitleProps) {
  const { t } = useTranslation("ui");
  const renameMutation = useRenameAskPunttProject(projectId);

  return (
    <BreadcrumbInlineRename
      title={name}
      canEdit={canEdit}
      isPending={renameMutation.isPending}
      onRename={(next) => renameMutation.mutate(next)}
      maxLength={MAX_ASK_PUNTT_PROJECT_NAME_LENGTH}
      triggerAriaLabel={t("projectBreadcrumbTitle.renameProjectWithName", {
        name,
      })}
      pencilAriaLabel={t("projectBreadcrumbTitle.renameProject")}
      inputAriaLabel={t("projectBreadcrumbTitle.projectName")}
      readOnlyTestId="ask-v2-project-title"
      triggerTestId="ask-v2-project-rename"
      pencilTestId="ask-v2-project-rename-button"
      inputTestId="ask-v2-project-rename-input"
    />
  );
}
